import styled from 'styled-components';

import { Row } from '@components/formStyles';
import Button from '@components/Button';

export const Container = styled.div`
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 12px;
  }
`;

export const Title = styled.span`
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    margin-bottom: 8px;
  }
`;

export const DynamicRow = styled(Row)`
  width: 100%;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
`;

export const TopWrapper = styled(DynamicRow)``;

export const BotWrapper = styled(DynamicRow)``;

export const DescriptionWrapper = styled.div`
  max-width: 792px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 24px;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 400;
`;

export const PriceWrapper = styled.div`
  min-width: 160px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;

export const PriceStartLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.grey1100};
  margin-bottom: 8px;
`;

export const Subtitle = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grey600};
`;

export const IconText = styled.span<{ isDark?: boolean }>`
  font-size: 12px;
  margin-left: 4px;
  color: ${({ theme, isDark }) =>
    isDark ? theme.palette.grey1100 : theme.palette.grey800};
`;

export const SubtitleSeperator = styled.div`
  height: 24px;
  width: 1px;
  background: ${({ theme }) => theme.palette.grey300};
  margin: 0 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 0;
    height: 0;
    margin-bottom: 8px;
  }
`;

export const Scoring = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 150px;
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: flex-start;
    margin-top: 16px;
  }
`;

export const ReadMore = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey800};
  cursor: pointer;
  font-size: 12px;
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const StyledButton = styled(Button)`
  width: 140px;
  height: 40px;
`;
